import { Controller } from "@hotwired/stimulus";
import { startMediaProcessingPoll } from "../../utils/mediaProcessing";

export default class extends Controller {
  static values = {
    hash: String,
    contentMediumId: Number,
    pollInterval: { type: Number, default: 2000 }
  };

  static targets = ["progressBar", "progressText", "container"];

  static outlets = ["circular-progress"]

  connect() {
    this.poller = null;
    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  startPolling() {
    this.poller = startMediaProcessingPoll({
      hash: this.hashValue,
      pollInterval: this.pollIntervalValue,
      onProgress: (progress) => this.updateProgress(progress),
      onComplete: (data) => console.log("ok"),
      onError: (error) => console.error("Error checking media status:", error)
    });
  }

  stopPolling() {
    if (this.poller) {
      this.poller.stop();
      this.poller = null;
    }
  }

  updateProgress(progress) {
    this.circularProgressOutlet.updateProgressValue(progress)
  }
}
